/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewThemeSetting
 */
export interface NewThemeSetting {
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    backgroundTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    primaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    primaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    secondaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    secondaryTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    errorColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    errorTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    warningColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    warningTextColor?: string;
    /**
     * 
     * @type {string}
     * @memberof NewThemeSetting
     */
    iconPack?: string;
    /**
     * 
     * @type {number}
     * @memberof NewThemeSetting
     */
    courierId?: number;
}

/**
 * Check if a given object implements the NewThemeSetting interface.
 */
export function instanceOfNewThemeSetting(value: object): value is NewThemeSetting {
    return true;
}

export function NewThemeSettingFromJSON(json: any): NewThemeSetting {
    return NewThemeSettingFromJSONTyped(json, false);
}

export function NewThemeSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewThemeSetting {
    if (json == null) {
        return json;
    }
    return {
        
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'backgroundTextColor': json['backgroundTextColor'] == null ? undefined : json['backgroundTextColor'],
        'primaryColor': json['primaryColor'] == null ? undefined : json['primaryColor'],
        'primaryTextColor': json['primaryTextColor'] == null ? undefined : json['primaryTextColor'],
        'secondaryColor': json['secondaryColor'] == null ? undefined : json['secondaryColor'],
        'secondaryTextColor': json['secondaryTextColor'] == null ? undefined : json['secondaryTextColor'],
        'errorColor': json['errorColor'] == null ? undefined : json['errorColor'],
        'errorTextColor': json['errorTextColor'] == null ? undefined : json['errorTextColor'],
        'warningColor': json['warningColor'] == null ? undefined : json['warningColor'],
        'warningTextColor': json['warningTextColor'] == null ? undefined : json['warningTextColor'],
        'iconPack': json['iconPack'] == null ? undefined : json['iconPack'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function NewThemeSettingToJSON(json: any): NewThemeSetting {
    return NewThemeSettingToJSONTyped(json, false);
}

export function NewThemeSettingToJSONTyped(value?: NewThemeSetting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'backgroundColor': value['backgroundColor'],
        'backgroundTextColor': value['backgroundTextColor'],
        'primaryColor': value['primaryColor'],
        'primaryTextColor': value['primaryTextColor'],
        'secondaryColor': value['secondaryColor'],
        'secondaryTextColor': value['secondaryTextColor'],
        'errorColor': value['errorColor'],
        'errorTextColor': value['errorTextColor'],
        'warningColor': value['warningColor'],
        'warningTextColor': value['warningTextColor'],
        'iconPack': value['iconPack'],
        'courierId': value['courierId'],
    };
}

